import { Map } from 'immutable';

import {
  PARTNERSHIP_TAG_RECIPIENT_READ_REQUEST,
  PARTNERSHIP_TAG_RECIPIENT_READ_SUCCESS,
  PARTNERSHIP_TAG_RECIPIENT_READ_FAILURE,
  PARTNERSHIP_TAG_RECIPIENT_UPDATE_REQUEST,
  PARTNERSHIP_TAG_RECIPIENT_UPDATE_SUCCESS,
  PARTNERSHIP_TAG_RECIPIENT_UPDATE_FAILURE,
} from './actions';
import Logger from '../../../lib/Logger';

export default function partnershipTagsRecipients(
  state = Map({
    isLoading: false,
    id: null,
    isSubmitting: false,
  }),
  action
) {
  Logger.log(
    'debug',
    `[partnershipTagsRecipients.reducers] partnershipTagsRecipients(%j, %j)`,
    state,
    action
  );

  switch (action.type) {
    case PARTNERSHIP_TAG_RECIPIENT_READ_REQUEST:
      return state.mergeDeep({
        isLoading: true,
      });

    case PARTNERSHIP_TAG_RECIPIENT_READ_SUCCESS:
      return state.mergeDeep({
        isLoading: false,
        lastUpdated: action.receivedAt,
        id: action.id,
      });

    case PARTNERSHIP_TAG_RECIPIENT_READ_FAILURE:
      return state.mergeDeep({
        isLoading: false,
      });

    case PARTNERSHIP_TAG_RECIPIENT_UPDATE_REQUEST:
      return state.mergeDeep({
        isLoading: true,
        form: {
          isSubmitting: true,
          success: null,
          errors: null,
        },
      });

    case PARTNERSHIP_TAG_RECIPIENT_UPDATE_SUCCESS:
      return state.mergeDeep({
        isLoading: false,
        id: action.id,
        form: {
          isSubmitting: false,
          success: true,
          errors: null,
        },
        lastUpdated: action.receivedAt,
      });

    case PARTNERSHIP_TAG_RECIPIENT_UPDATE_FAILURE:
      return state
        .mergeDeep({
          isLoading: false,
          form: {
            isSubmitting: false,
            success: false,
            errors: null,
          },
        })
        .setIn(['form', 'errors'], action.error);

    default:
      return state;
  }
}

Logger.log('silly', `partnershipTagsRecipients.reducers loaded.`);
